var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { ChildProperty, Collection, Property } from '@syncfusion/ej2-base';
import { RibbonGalleryItem } from './ribbon-gallery-item';
/**
 * Defines the ribbon gallery group.
 */
export class RibbonGalleryGroup extends ChildProperty {
}
__decorate([
    Collection([], RibbonGalleryItem)
], RibbonGalleryGroup.prototype, "items", void 0);
__decorate([
    Property('')
], RibbonGalleryGroup.prototype, "header", void 0);
__decorate([
    Property('auto')
], RibbonGalleryGroup.prototype, "itemWidth", void 0);
__decorate([
    Property('auto')
], RibbonGalleryGroup.prototype, "itemHeight", void 0);
__decorate([
    Property('')
], RibbonGalleryGroup.prototype, "cssClass", void 0);
